import styled from 'styled-components'

export const PrintButton = styled.button`
    border: none;
    background: #EC4899;
    cursor: pointer;
    font-size: 16px;
    color: white;

    span {
        font-size: 16px;
        margin-right: 5px;
    }
`